import { useEffect, useState } from "react";

interface TypewriterOptions {
  speed?: number;
  startDelay?: number;
}

export function useTypewriter(text: string, opts: TypewriterOptions = {}) {
  const { speed = 60, startDelay = 400 } = opts;
  const [display, setDisplay] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let timer: ReturnType<typeof setTimeout> | undefined;

    setDisplay("");
    setDone(false);

    const start = window.setTimeout(() => {
      let i = 0;
      const step = () => {
        if (cancelled) return;
        i += 1;
        setDisplay(text.slice(0, i));
        if (i < text.length) {
          timer = setTimeout(step, speed);
        } else {
          setDone(true);
        }
      };
      step();
    }, startDelay);

    return () => {
      cancelled = true;
      window.clearTimeout(start);
      if (timer) clearTimeout(timer);
    };
  }, [text, speed, startDelay]);

  return { display, done };
}
